export default "__VITE_ASSET__BLDf0$ls__"